import { cn } from "@/lib/utils";
import { scoreBg } from "@/lib/format";

export function ScoreCard({
  label,
  score,
  caption,
  invert = false,
}: {
  label: string;
  score: number;
  caption?: string;
  invert?: boolean;
}) {
  const display = invert ? 100 - score : score;
  return (
    <div className="rounded-xl border border-border bg-card p-5 shadow-soft">
      <div className="flex items-baseline justify-between">
        <div className="text-xs uppercase tracking-widest text-muted-foreground">{label}</div>
        <div className="font-display text-3xl font-semibold tabular-nums">{display}</div>
      </div>
      <div className="mt-3 h-2 w-full overflow-hidden rounded-full bg-muted">
        <div
          className={cn("h-full rounded-full transition-all", scoreBg(score, invert))}
          style={{ width: `${display}%` }}
        />
      </div>
      {caption && <div className="mt-2 text-xs text-muted-foreground">{caption}</div>}
    </div>
  );
}
